import { z } from 'zod';

const CategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  level: z.number(),
});

const TagSchema = z.object({
  id: z.string(),
  name: z.string(),
  categoryName: z.string(),
  userHasAccess: z.boolean().optional(),
  get children() {
    return z.array(TagSchema);
  },
});

export type PlanLabel = z.infer<typeof TagSchema>;

const HierarchySchema = z.object({
  id: z.string(),
  name: z.string(),
  categories: z.array(CategorySchema),
  tags: z.array(TagSchema),
});

export const treeDataResponseSchema = z.array(HierarchySchema);

export const updateTagsRequestSchema = z.array(z.string());
export const updateTagsResponseSchema = z.unknown();
